import { render, staticRenderFns } from "./weishenpi.vue?vue&type=template&id=960deb18&scoped=true&"
import script from "./weishenpi.vue?vue&type=script&lang=js&"
export * from "./weishenpi.vue?vue&type=script&lang=js&"
import style0 from "./weishenpi.vue?vue&type=style&index=0&id=960deb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960deb18",
  null
  
)

export default component.exports